module.exports = __webpack_public_path__ + "img/sy.c29b19bf.svg";